import { Icon } from '@adobe/react-spectrum';

const LeftArrowIcon = props => {
  return (
    <Icon {...props}>
      <svg
        focusable="false"
        aria-hidden="true"
        role="img"
        class="spectrum-UIIcon-ChevronLeftLarge"
      >
        <path d="M9.605 13.843L3.55 8l6.056-5.84A1.248 1.248 0 1 0 7.876.363L.882 7.1a1.243 1.243 0 0 0 .003 1.797l6.988 6.742a1.248 1.248 0 1 0 1.732-1.796z"></path>
      </svg>
    </Icon>
  );
};

export default LeftArrowIcon;
